class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
    this.closeButtons = this.drawer.querySelectorAll('[data-cart-drawer-close]');
    this.form = this.drawer.querySelector('#CartDrawerForm');
    this.discountInput = this.drawer.querySelector('#CartDrawerDiscount');
    this.bindEvents();
  }

  bindEvents() {
    // Open triggers: add data-cart-drawer-open on your cart icon, etc.
    document.querySelectorAll('[data-cart-drawer-open]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    this.overlay?.addEventListener('click', () => this.close());
    this.closeButtons.forEach(btn => btn.addEventListener('click', () => this.close()));

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.close();
    });

    if (!this.form) return;

    // Qty and remove handlers
    this.form.addEventListener('click', (event) => {
      const target = event.target;

      const qtyBtn = target.closest('[data-qty-change]');
      if (qtyBtn) {
        this.handleQtyChange(qtyBtn);
        return;
      }

      const removeBtn = target.closest('[data-remove-line]');
      if (removeBtn) {
        this.handleRemove(removeBtn);
      }
    });

    // Checkout: apply discount code by redirecting to checkout URL
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      const code = this.discountInput ? this.discountInput.value.trim() : '';
      const url = code
        ? `/checkout?discount=${encodeURIComponent(code)}`
        : `/checkout`;
      window.location.href = url;
    });

    // Discount "Apply" button just focuses the field (optional)
    const applyBtn = document.getElementById('CartDrawerDiscountApply');
    if (applyBtn && this.discountInput) {
      applyBtn.addEventListener('click', () => {
        this.discountInput.focus();
      });
    }
  }

  open() {
  
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');

  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }

  handleQtyChange(button) {
    const lineItemEl = button.closest('[data-line]');
    if (!lineItemEl) return;
    const line = Number(lineItemEl.dataset.line);

    const input = lineItemEl.querySelector('[data-qty-input]');
    const current = Number(input.value || 0);
    const delta = Number(button.getAttribute('data-qty-change'));
    const newQty = Math.max(0, current + delta);

    this.updateLine(line, newQty);
  }

  handleRemove(button) {
    const lineItemEl = button.closest('[data-line]');
    if (!lineItemEl) return;
    const line = Number(lineItemEl.dataset.line);
    this.updateLine(line, 0);
  }

  updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    })
      .then(res => res.json())
      .then(() => this.refreshDrawer())
      .catch(err => console.error('Cart update error', err));
  }

  // Re-render section from server (like Dawn)
  refreshDrawer() {
    const url = `${window.location.pathname}?section_id=cart-drawer`;
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newDrawer = tmp.querySelector('#CartDrawer');
        if (!newDrawer) return;
        this.drawer.replaceWith(newDrawer);
        // re-init on new markup
        new CartDrawer();
        this.open();
      })
      .catch(err => console.error('Cart drawer refresh error', err));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
});